<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <origen-deuda-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import OrigenDeudaProvider from "../../../../providers/OrigenDeudaProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import OrigenDeudaForm from "../OrigenDeudaForm";
  
    

    export default {
        name: "OrigenDeudaUpdate",
        
        components: { OrigenDeudaForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.origenDeuda.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    nombre: this.item.nombre
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    OrigenDeudaProvider.updateOrigenDeuda(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateOrigenDeuda)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

